import About from "./About";
import Contact from "./Contact";
import Navbar from "./Navbar";
import Playground from "./Playground";
import Projects from "./Projects";
import Skills from "./Skills";
import Testimonials from "./Testimonials";

export {
    About,
    Contact,
    Navbar,
    Playground,
    Projects,
    Skills,
    Testimonials
}


// WEBPACK FOOTER //
// ./src/components/index.js